// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { db } from '../../firebase.js';
import { useAuth } from '../../context/AuthContext.tsx';
import BackButton from '../../components/ui/atoms/BackButton.tsx';
import fetchWithAuth from '../../utils/fetchWithAuth.ts';

export default function AdminFeedback() {
  const { user } = useAuth();
  const allowedEmail = 'admin@panpals.de';

  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('unread');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // fetchWithAuth returns the parsed JSON array directly
        const data = await fetchWithAuth(
          `/api/admin/feedback?read=${activeTab === 'read'}`
        );
        console.log('🪄 fetched feedback array:', data);
        setFeedback(data);
      } catch (err) {
        console.error('Could not load feedback', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [activeTab]);

  const markAsRead = async (id) => {
    await fetchWithAuth(`/api/admin/feedback/${id}/read`, { method: 'PATCH' });
    setFeedback((prev) =>
      prev.map((f) => (f.id === id ? { ...f, read: true } : f))
    );
  };

  if (!user || user.email !== allowedEmail) {
    return <div className="p-4 text-red-500">Access Denied</div>;
  }

  const filtered = feedback.filter((f) =>
    activeTab === 'read' ? f.read : !f.read
  );

  const tagColor = {
    bug: 'bg-red-100 text-red-700',
    feature: 'bg-blue-100 text-blue-700',
    comment: 'bg-gray-100 text-gray-700',
  };

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <BackButton />
      <h1 className="text-xl font-bold mb-4">🛡️ Admin Feedback Panel</h1>

      {/* Tabs */}
      <div className="flex gap-4 mb-4">
        <button
          className={`px-3 py-1 rounded ${
            activeTab === 'unread'
              ? 'bg-black text-white'
              : 'bg-gray-200 text-gray-700'
          }`}
          onClick={() => setActiveTab('unread')}
        >
          Unread
        </button>
        <button
          className={`px-3 py-1 rounded ${
            activeTab === 'read'
              ? 'bg-black text-white'
              : 'bg-gray-200 text-gray-700'
          }`}
          onClick={() => setActiveTab('read')}
        >
          Read
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : filtered.length === 0 ? (
        <p>No feedback to show.</p>
      ) : (
        <div className="space-y-4">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="border p-4 rounded shadow-sm bg-white relative"
            >
              <p className="text-sm text-gray-500 mb-1">
                {item.createdAt
                  ? new Date(item.createdAt).toLocaleString()
                  : 'Unknown time'}
              </p>

              <span
                className={`text-xs font-semibold px-2 py-1 rounded uppercase ${tagColor[item.type] || 'bg-gray-100'}`}
              >
                {item.type}
              </span>

              {item.email && (
                <p className="text-sm mt-2">
                  <strong>Email:</strong> {item.email}
                </p>
              )}
              {item.title && (
                <p className="text-sm">
                  <strong>Title:</strong> {item.title}
                </p>
              )}
              <p className="text-sm mt-1">
                <strong>Description:</strong>
                <br />
                {item.description}
              </p>
              {item.extra && (
                <p className="text-sm mt-2 text-gray-600 whitespace-pre-wrap">
                  <strong>Extra:</strong>
                  <br />
                  {item.extra}
                </p>
              )}

              {!item.read && (
                <button
                  onClick={() => markAsRead(item.id)}
                  className="absolute top-2 right-2 text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded"
                >
                  Mark as read
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
